import React from 'react';

import { CalendlyBubble } from 'components/SmartAssistantComponents/CalendlyBubble';
import { ChatAttachmentsBubble } from 'components/SmartAssistantComponents/ChatAttachmentsBubble';
import { EmailHandoffFormBubble } from 'components/SmartAssistantComponents/EmailHandoffFormBubble';
import { MessageBubble } from 'components/SmartAssistantComponents/MessageBubble';
import { ShopifyProductsBubble } from 'components/SmartAssistantComponents/ShopifyProductsBubble';
import { ViewMode } from 'shared/enums/ViewMode';
import {
  ChatMessage,
  EmailHandoffToolEventData,
  ForcedToolInvocation,
  ShopifyDisplayProductsToolEventData,
  ToolEventType
} from 'shared/interfaces/ChatMessage';
import { SmartAssistantVisualConfig } from 'shared/interfaces/SmartAssistant';
import { ToolConfig } from 'shared/interfaces/tools/Tool';

interface ChatMessageRendererProps {
  message: ChatMessage;
  smartAssistantVisualConfig: SmartAssistantVisualConfig;
  viewMode: ViewMode;
  toolConfigs?: ToolConfig[];
  forceToolInvocation?: (forcedToolInvocation: ForcedToolInvocation) => void;
}

export function ChatMessageRenderer({
  message,
  smartAssistantVisualConfig,
  viewMode,
  toolConfigs,
  forceToolInvocation
}: ChatMessageRendererProps) {
  if (message.partialResponseSubject) {
    return <MessageBubble message={message} smartAssistantVisualConfig={smartAssistantVisualConfig} />;
  }
  if (message.text || message.attachments) {
    return (
      <>
        <ChatAttachmentsBubble message={message} smartAssistantVisualConfig={smartAssistantVisualConfig} />
        {message.text && <MessageBubble message={message} smartAssistantVisualConfig={smartAssistantVisualConfig} />}
      </>
    );
  }
  if (message.toolEvent?.type === ToolEventType.CALENDLY_TOOL_USER_SHOWED_INTENT_TO_SCHEDULE_MEETING) {
    return (
      <CalendlyBubble toolConfigs={toolConfigs} smartAssistantVisualConfig={smartAssistantVisualConfig} forIntent />
    );
  }
  if (message.toolEvent?.type === ToolEventType.SHOPIFY_DISPLAY_PRODUCTS) {
    return (
      <ShopifyProductsBubble
        smartAssistantVisualConfig={smartAssistantVisualConfig}
        products={(message.toolEvent.data as ShopifyDisplayProductsToolEventData)?.displayedProducts}
      />
    );
  }
  if (message.toolEvent?.type === ToolEventType.EMAIL_HANDOFF) {
    return (
      <EmailHandoffFormBubble
        toolConfigs={toolConfigs}
        viewMode={viewMode}
        forceToolInvocation={forceToolInvocation}
        formFilledData={message.toolEvent.data as EmailHandoffToolEventData}
        smartAssistantVisualConfig={smartAssistantVisualConfig}
      />
    );
  }
  // Add more tool event renderers here
  return null;
}
